<template>
  <div class="container undertaking-inspection">
    <div class="item">
      <img src="../../assets/images/search/zgjh@2x.png" alt="" />
      <p>基金、租赁、信托、人寿、财险、投行、期货、养老金等多个行业的子公司。</p>
      <a href="http://www.ccb.com/tran/WCCMainPlatV5?CCB_IBSVersion=V5&TXCODE=NBH001" target="_blank">立即查询</a>
    </div>
    <div class="item">
      <img src="../../assets/images/search/ac@2x.png" alt="" />
      <p>安诚财险为您提供意健险、财产险、车险保单在线查验功能，安诚合作伙伴专属查验功能。</p>
      <a href="http://www.e-acic.com/AcicWebManager/template/main" target="_blank">立即查询</a>
    </div>
    <div class="item">
      <img src="../../assets/images/search/yg@2x.png" alt="" />
      <p>财产保险、人寿保险、信用保证保险、资产管理等多家专业子公司。</p>
      <a href="http://query.sinosig.com/testfwl/fwebs/Prpcmain/search_notcar2.jsp;" target="_blank">立即查询</a>
    </div>
    <div class="item">
      <img src="../../assets/images/search/ta@2x.png" alt="" />
      <p>保险精算、保险经纪、保险、保险信息、健康保险 、保险咨询、人寿保险、金融服务、金融咨询、信托。</p>
      <a href="https://www.95505.com.cn/customer_service/electronic_policy.html" target="_blank">立即查询</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UndertakingInspection',
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.undertaking-inspection {
  width: 1300px;
  margin: 0 auto;
  overflow: hidden;
  padding: 30px 0 100px;
  .item {
    width: 25%;
    float: left;
    text-align: center;
    img {
      height: 100px;
      width: 262px;
      border: 1px solid #bbb;
      padding: 20px 10px;
    }
    p {
      padding-left: 20px;
      width: 290px;
      text-align: left;
      font-size: 18px;
      font-weight: 400;
      line-height: 32px;
      color: #222222;
      margin-top: 10px;
      height: 130px;
    }
    a {
      border: 0;
      margin-top: 80px;
      padding: 12px 39px;
      background: white;
      border: 1px solid #019bce;
      color: #019bce;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      outline: none;
      transition: 400ms ease all;
      &:hover {
        background: #019bce;
        color: white;
        cursor: pointer;
      }
    }
  }
}
</style>
